import { css } from "@emotion/react";
import { Button, Theme, useTheme } from "@mui/material";
import Link from "next/link";
import { useEffect } from "react";

import { responseModalContentRootDesignStyle } from "~/components/database/detail/response-modal-content/design";
import { flexRow } from "~/lib/client/design";
import { engFont } from "~/lib/client/fonts";
import { constants } from "~/lib/constants";

/**
 * @package
 * @param responseAnswers
 * @param closeModal
 * @param setModalClosable
 * @constructor
 */
const ResponseSuccess = ({
  categories,
  closeModal,
  setModalClosable,
}: {
  categories: { id: number; name: string }[];
  closeModal: () => void;
  setModalClosable: (closable: boolean) => void;
}) => {
  const theme = useTheme();

  useEffect(() => {
    setModalClosable(true);
  }, [setModalClosable]);

  return (
    <div css={rootStyle}>
      <p css={thankYouStyle(theme)} className={engFont.className}>
        THANK YOU
      </p>
      <p css={messageStyle}>
        データベースへの投稿ありがとうございます。
        <br />
        書き込み反映後に通知でお知らせします。
      </p>
      <div css={videoContainer}>
        <video
          loop
          muted
          playsInline
          controls
          style={{
            width: "80%",
            height: "auto",
            margin: "2rem auto",
          }}
        >
          <source
            src={constants.videoUrls.reachToNotification}
            type="video/mp4"
          />
        </video>
      </div>
      <p css={messageStyle}>
        他のデータベースへの投稿やクエストを実行して、
        {categories.map((c) => `【${c.name}】`).join(" ")}を応援しよう！
      </p>
      <ul css={categoryLinkListContainerStyle(theme)}>
        {categories.map((c) => (
          <li key={c.id}>
            <Link href={`/category/${c.id}`}>
              {c.name}
              {" - "}
              {`https://www.fussy.fun/category/${c.id}`}
            </Link>
          </li>
        ))}
      </ul>
      <div css={buttonContainerStyle}>
        <Button onClick={closeModal} variant={"outlined"}>
          閉じる
        </Button>
      </div>
    </div>
  );
};

const rootStyle = [
  responseModalContentRootDesignStyle,
  css`
    padding: 2rem;
  `,
];

const thankYouStyle = (theme: Theme) => css`
  ${flexRow};
  justify-content: center;
  font-size: 36px;
  color: ${theme.palette.primary.main};
`;

const messageStyle = css`
  ${flexRow};
  justify-content: center;
`;

const videoContainer = css`
  display: flex;
  justify-content: center;
`;

const buttonContainerStyle = css`
  ${flexRow};
  justify-content: flex-end;
  margin-top: 5rem;
`;

const categoryLinkListContainerStyle = (theme: Theme) => css`
  li {
    margin-top: 1rem;
  }

  a {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
  }
`;

export default ResponseSuccess;
